import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HtmlTemplateService } from './html-templates.service';

@NgModule({
  providers: [HtmlTemplateService, provideHttpClient(withInterceptorsFromDi())],
})
export class HtmlTemplateModule {}
